<template>
  <v-dialog v-model="showDialog" v-if="showDialog" persistent scrollable :max-width="maxWidth || 775" :width="setWidth" v-on:keydown.enter="defaultButtonAction">
    <v-card>
      <v-card-title class="py-3 font-weight-medium base-dialog__title resBlue darken-1 white--text">
        <v-icon v-if="showTitleIcon"
                :size="titleIconSize"
                class="mr-2"
                color="white">
          {{ iconCode }}
        </v-icon>
        <span class="resBlue darken-1 white--text body-2">
          {{ dialogTitle }}
        </span>
        <v-spacer></v-spacer>
        <v-icon @click="cancel" color="white">close</v-icon>
      </v-card-title>
      <v-card-text :style="calculateHeight" class="base-dialog px-4">
        <v-row>
          <v-col cols="7" class="res-col-10">
            <label>Template name</label>
            <res-text-field v-model="template.name" :filled="template.isArchived" :readonly="template.isArchived" placeholder="Template name goes here" :maxLength="255" fieldName="Template name"></res-text-field>
          </v-col>
          <v-col cols="1" class="px-0">
            <br />
            <label>Order By:</label>
          </v-col>
          <v-col cols="3">
            <br/>
            <res-select v-model="template.sortType" :items="sortOptions"></res-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="res-col-10">
            <span class="font-weight-bold">Properties:</span><br />

            Please select the properties you would like to add / remove for this template.
          </v-col>
        </v-row>

        <res-two-list-select listType="Properties" v-model="template.selectedProperties" :allSelectable="allProperties" :readonly="template.isArchived"></res-two-list-select>

      </v-card-text>
      <v-card-actions class="px-4 pt-0 pb-4 d-flex justify-end">
        <res-button v-if="mode == 'edit'"
                    :outline="true"
                    :icon="false"
                    font-size="14px"
                    height="30px" 
                    :buttonText="archiveButtonText"
                    capitalize="false"
                    backgroundColor='white'
                    borderColor='var(--v-resRed-base)'
                    buttonTextColor='var(--v-resRed-base)'
                    @click='archive'></res-button>
        <v-btn v-if="mode == 'edit' && template.isArchived == false" height="30px" rounded outlined elevation="0" color="resBlue darken1" @click="copy">
          COPY
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn height="30px" rounded elevation="0" outlined :color="cancelButtonColor" @click="cancel">
          {{ cancelButtonText }}
        </v-btn>
        <v-btn v-if="template.isArchived == false" height="30px" rounded elevation="0" :disabled="isSaveDisabled" class="resGreen white--text" width="[saveButtonWidth ? saveButtonWidth : '']" @click="save">
          {{ saveButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import ResButton from '@/components/base/ResButton.vue';
  import ResTextField from '@/components/base/ResTextField.vue';
  import ResTwoListSelect from '@/components/base/ResTwoListSelect.vue';
  import ResSelect from '@/components/base/ResSelect.vue';
  import IsNullOrWhitespaceMixin from '@/mixins/isNullOrWhitespace.js';
  
  import {Constants} from '@/utilities/constants/index.js'
  import propertyService from '@/services/property';

  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'NewEditTemplateDialog',
    components: {
      ResButton,
      ResTextField,
      ResTwoListSelect,
      ResSelect
    },
    data: function () {
      return {
        properties: [],
        sortOptions: [
          {
            text: 'Alphabetic',
            value: 0
          },
          {
            text: 'GL Account',
            value: 1
          },
          {
            text: 'Custom',
            value: 2
          }
        ]
      }
    },
    props: {
      showDialog: {
        type: Boolean
      },
      mode: {
        type: String
      },
      template: {
        type: Object,
        default: function () {
          return {
            templateId: Constants.EMPTY_GUID,
            name: '',
            selectedProperties: [],
            isArchived: false,
            sortType: 1
          }
        }
      },
      copyName: {
        type: String
      },
      maxWidth: {
        type: Number
      },
      setWidth: {
        type: Number
      },
      setHeight: {
        type: Number
      }
    },
    mixins: [IsNullOrWhitespaceMixin],
    methods: {
      ...mapActions(['fetchDropdown', 'initializeStoreDropdown']),
      save() {
        if (!this.isSaveDisabled) {
          this.$emit('save', this.template)
        }
      },
      cancel() {
        this.$emit('cancel', true)
      },
      archive() {
        if (this.mode == 'edit') {
          this.$emit('archive', this.template.templateId)
        }
      },
      copy() {
        if (this.mode == 'edit') {
          this.$emit('copy', this.template)
        }
      }
    },
    computed: {
      ...mapGetters(['currentLoading']),
      dialogTitle() {
        if (this.mode == 'edit') {
          return 'Edit ' + this.template.name;
        } else if (this.mode == 'copy') {
          return 'Copy ' + this.copyName;
        } else {
          return 'New Template';
        }
      },
      showTitleIcon() {
        return this.mode == 'copy';
      },
      iconCode() {
        return this.mode == 'copy' ? 'mdi-content-copy' : '';
      },
      saveButtonText() {
        return this.mode == 'edit' ? 'SAVE' : 'CREATE TEMPLATE';
      },
      cancelButtonColor() {
        return this.template.isArchived ? 'resBlue darken1' : 'resRed base';
      },
      cancelButtonText() {
        return this.template.isArchived ? 'CLOSE' : 'CANCEL';
      },
      archiveButtonText() {
        return this.template.isArchived ? 'UN-ARCHIVE' : 'ARCHIVE';
      },
      calculateHeight() {
        return "height:" + this.setHeight + "px";
      },
      isSaveDisabled() {
        // make sure we have selected everything
        if (typeof this.template === 'undefined' || this.template == null) {
          return true;
        }
        if (this.isNullOrWhitespace(this.template.name) ||
          (typeof this.template.selectedProperties == 'undefined' || this.template.selectedProperties.length <= 0)) {
          return true;
        }
        return false;
      },
      allProperties() {
        return this.properties;
      },
    },
    async created() {
      setTimeout(() => {
        if (typeof(this.template.sortType) == "undefined") {
          this.template.sortType = 1;
        }
      });
      let propertyData = await propertyService.getDropdown();
      if (propertyData && propertyData.data) {
        this.properties = propertyData.data;
      } else {
        this.properties = [];
      }
    }
  };
</script>

<style lang="scss" scoped>
  .base-dialog {
    .res-col-10 {
      padding-top: 10px !important;
      padding-bottom: 10px !important;
    }

    .v-btn-toggle--rounded {
      border-radius: 6px;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
    }
  }

  .v-input.v-input--dense.v-text-field.v-text-field--outlined::v-deep {
    .v-input__slot
    {
      min-height: 30px !important;
      border-radius: 6px;
    }
  }

  .theme--light.v-btn-toggle::v-deep {
    .v-btn.v-btn
    {
      border: solid 1px var(--v-resGrey-darken1) !important;
    }
  }

  .v-input.v-input--dense.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row::v-deep {
    .v-messages
    {
      display: none;
    }

    .v-input__slot {
      margin-bottom: 0px !important
    }

    .v-input--selection-controls__input {
      height: 20px !important;
      width: 20px !important;
    }

    .v-input--selection-controls__ripple {
      width: 20px;
      height: 20px;
      left: -10px;
    }

    .v-icon--svg {
      height: 15px !important;
      width: 15px !important;
    }
  }

  .v-input.future-period-start-selector::v-deep {
    div.menuable__content__active {
    max-height: 132px !important;
  }
  } 
</style>

